/* eslint-disable jira/filename-case */
export const SWAG_APOLLO_CLIENT = 'SWAG';
export const GIRA_APOLLO_CLIENT = 'gira';
export const REST_APOLLO_CLIENT = 'REST';
